import {useQuery} from '@tanstack/react-query';
import {API} from '@chekin/api';
import {QUERY_CACHE_KEYS, LockConditions} from '@chekin/core';
import {useRemoteAccessEnv} from '../env';

type UseFetchLockConditionsProps = {
  enabled?: boolean;
};

function useFetchLockConditions({enabled = true}: UseFetchLockConditionsProps = {}) {
  const {reservationId, isTokenValid} = useRemoteAccessEnv();
  const enabledFetching = Boolean(isTokenValid && reservationId && enabled);

  return useQuery<LockConditions, Error>({
    queryKey: [QUERY_CACHE_KEYS.lockConditions, reservationId],
    queryFn: () => API.locks.getLockConditions(`reservation_id=${reservationId}`),
    enabled: enabledFetching,
    refetchOnWindowFocus: false,
    staleTime: 3000,
  });
}

export {useFetchLockConditions};
